import React from 'react';
import styles from './index.module.scss';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Assign = ({
  label,
  placeholder,
  options,
  selectedValue,
  changeSelectedValue,
  btnText,
  btnSize,
  btnColor,
  btnClick,
  isDisabled,
  btnDisabled,
  className,
}) => {
  return (
    <div className={styles.operationalView}>
      <Dropdown
        label={label}
        placeholder={placeholder}
        options={options}
        value={selectedValue}
        onChange={changeSelectedValue}
        isDisabled={isDisabled}
        name={label}
      />
      <Button
        text={btnText}
        size={btnSize}
        color={btnColor}
        onClick={btnClick}
        disabled={!selectedValue || btnDisabled}
        className={cn(styles.actionButton, className)}
      />
    </div>
  );
};

Assign.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.array,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  changeSelectedValue: PropTypes.func.isRequired,
  btnText: PropTypes.string.isRequired,
  btnSize: PropTypes.string,
  btnColor: PropTypes.string,
  btnClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  btnDisabled: PropTypes.bool,
  className: PropTypes.string,
};

Assign.defaultProps = {
  isDisabled: false,
  btnDisabled: false,
};

export default Assign;
